import { render } from "./Prolong.vue?vue&type=template&id=b9af48b4"
import script from "./Prolong.vue?vue&type=script&lang=js"
export * from "./Prolong.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__